import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";
import { useAjustes } from "../datos/useAjustes";
import {
  diasSinContacto,
  semaforo,
  type ColorSemaforo,
} from "../dominio/semaforo";
import type { Negocio } from "../dominio/tipos";

const CLASE_COLOR: Record<ColorSemaforo, string> = {
  verde: "bg-green-600",
  azul: "bg-[#3D8BD4]",
  amarillo: "bg-yellow-500",
  naranja: "bg-orange-500",
  rojo: "bg-red-600",
};

/** Punto de color del semáforo (SPEC.md §4) con los umbrales de Ajustes. */
export const Semaforo = ({
  negocio,
  conTexto = false,
  className,
}: {
  negocio: Pick<
    Negocio,
    "etapa" | "ultimo_contacto" | "created_at" | "consultoria_realizada_at"
  >;
  conTexto?: boolean;
  className?: string;
}) => {
  const translate = useTranslate();
  const { ajustes } = useAjustes();
  const color = semaforo(negocio, ajustes.semaforo);
  if (!color) return null;
  const dias = diasSinContacto(negocio);
  const titulo = `${translate(`nevora.semaforo.${color}`)} · ${translate("nevora.semaforo.dias", { smart_count: dias })}`;
  return (
    <span
      className={cn("inline-flex items-center gap-1.5", className)}
      role="img"
      title={titulo}
      aria-label={titulo}
    >
      <span
        className={cn("inline-block size-2.5 rounded-full", CLASE_COLOR[color])}
      />
      {conTexto ? (
        <span className="text-xs text-muted-foreground">
          {translate("nevora.semaforo.dias", { smart_count: dias })}
        </span>
      ) : null}
    </span>
  );
};
